module.exports = __webpack_public_path__ + "static/media/us.da1c4f85.svg";